import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextareaAutosize } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import { FaRegStar } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";
import { sendfeedback } from "../../actions/users";
import { withStyles } from "@material-ui/core/styles";
import { useHistory, useLocation } from 'react-router-dom';
import Loader from "../../lib/ui/loader/Loader";

const FeedBackPopup = () => {
    const location = useLocation();
    const appointmentData = location.state?.appointmentData || location.state?.appointment
    const [doctorValue, setDoctorValue] = useState(0);
    const [open, setOpen] = useState(true)
    const [loading, setloading] = useState(false)
    const [comment, setComment] = useState("");
    const history = useHistory();

    useEffect(() => {
    }, [appointmentData]);

    const handleCloseFeedback = () => {
        setOpen(false)
        history.push("/patient-dashboard");
    };

    const StyledRating = withStyles({
        icon: {
            fontSize: "24px",
            margin: "0 4px",
        },
        iconFilled: {
            fontSize: "24px",
        },
        iconHover: {
            fontSize: "24px",
        },
    })(Rating);

    const handleSubmitFeedback = async () => {
        setloading(true)
        const body = {
            doctorId: appointmentData?.doctorId,
            stars: doctorValue,
            comment,
            patientId: appointmentData?.patientId,
        };
        console.log("body")

        try {
            const response = await sendfeedback(body);
            history.push("/patient-dashboard");
        } catch (error) {
            console.error("Error submitting feedback:", error);
        } finally {
            setloading(false)

        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleCloseFeedback}
            PaperProps={{
                style: {
                    minHeight: "450px",
                    width: "600px",
                    padding: "20px",
                },
            }}
        >
            {loading && (
                <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", zIndex: 10, background: "rgba(255, 255, 255, 0.7)" }}>
                    <Loader />
                </div>
            )}
            <DialogTitle style={{ textAlign: "center", fontWeight: "500" }}>Rate your experience ?</DialogTitle>
            <DialogContent
                style={{
                    padding: "0 !important",
                }}
            >
                <div className="flexCol alignCenter" style={{ gap: "10px" }}>
                    <span style={{ fontSize: "16px" }}>Doctor Rating</span>
                    <StyledRating
                        name="customized-color"
                        value={doctorValue}
                        onChange={(event, newValue) => {
                            setDoctorValue(newValue);
                        }}
                        getLabelText={(value) => `${value} Star${value !== 1 ? "s" : ""}`}
                        precision={1}
                        icon={<FaStar size={24} color="#23A4C4" />}
                        emptyIcon={<FaRegStar size={24} color="#23A4C4" />}
                    />
                </div>
                <div className="flexCol">
                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                        <span style={{ fontSize: "16px", fontWeight: "500" }}>Other Comments</span>
                    </div>

                    <TextareaAutosize
                        className="commentTxtArea"
                        aria-label="comments"
                        minRows={4}
                        placeholder="Share your thoughts here..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        onFocus={(e) => e.target.style.border = "1px solid #24A4C4"}
                    />
                </div>
                <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "20px" }}>
                    <Button
                        variant="outlined"
                        onClick={handleCloseFeedback}
                        color="primary"
                        style={{
                            textTransform: "none",
                            marginRight: "8px",
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{
                            textTransform: "none",
                            color: "white",
                        }}
                        onClick={handleSubmitFeedback}
                    >
                        Submit
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default FeedBackPopup;
